import { DAILY_TYPE, STRATEGY_TYPE, POOL_ACT_TYPE } from '@/constants/crumbs-type';
// import ActivityGoods from './components/activityGoods/'
// import ActivityOperateChildren from './components/avenueOperate/route-config';
import Zongcu from '../components/zongcuActivity';
import zongcuActivityChildren from '../components/zongcuActivity/route-config';
import SignUp from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/sign-up';
// import CreateRoomActivity from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/create-room-activity';
import AcoreCreateRoomActivity from '@/pages/activity-manage/merchants/venue-detail/pages/acore-create-room-activity';
import PoolInfoHeaderWrapper from '@/pages/channel-service/pages/channel/open-registration-process/collection-list/poolInfo-header-wrapper';
import QualificationSettings from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/qualification-settings';
import QualificationForAssembly from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/qualification-for-assembly';
import SceneSetting from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/scene-setting';
import RegisteredMaterials from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/registered-materials';
import CollectionPoolSettings from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/collection-pool-settings';
import AuditManagement from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/audit-management';
import MyCreateFunc from '../my-create-micro';
import MyCreateFuncChildren from '../my-create-micro/route-config';
import DistributePage from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/distribute-page';
import CrossSessionJumps from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/cross-session-jumps';
import ManagerPending from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/manager-pending';
import ParticipantsPending from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/participants-pending';
import Container from '@/components/container';
import SelectSetting from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/select-setting';
import data from './data';
import Microapp from '@/components/micro-app';
import React from 'react';
import TouchMenus from './material-pool-manage/daily-goods-strategy-detail/route-config';
import env from '@/env';
// 登月
import McManage, { routeItem } from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/mc-manage';

/* 品店策略 */
import DailyMaterialPoolManage from './material-pool-manage';
import DailyGoodsDetail, { GoodsDetailSetExtraHeaderProps } from './material-pool-manage/daily-goods-detail';
import DailyGoodsStrategyNew, { StrategyNewExtraHeaderProps } from './material-pool-manage/daily-goods-strategy-new';
import DailyGoodsStrategySet, { StrategySetExtraHeaderProps } from './material-pool-manage/daily-goods-strategy-set';
import DailyGoodsStrategyRangeSet, {
  StrategyRangeSetExtraHeaderProps,
} from './material-pool-manage/daily-goods-strategy-rangeSet';
import DailyGoodsStrategyDetail from './material-pool-manage/daily-goods-strategy-detail';
import MicroWrapper from '../components/micro-wrapper';
import { DAILY_ACTIVITY_MATERIAL } from '@/constants/frontend-menus';
import MaterialCollectionDaily from './material-pool-manage/material-collection-daily';
import MyCollectionChildren from './material-pool-manage/material-collection-daily/route-config';
import { getQuery } from '@/common/utils';
import TfPandora from '../../../../../src/micro-app/tf-pandora';
import ViewSelectRule from './../viewSelectRule';
import PoolRule from './../pool-rule';

import TowerProject from './tower-project';

export function getTitle(context) {
  const activityId = getQuery('activityId');
  const result = [];
  const path = `/activity-manage/myCreate/daily-activities-manager/materials/distribute/roomlist?entry=0&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}`;
  if (context.breadCrumbs.dailyData?.roomName) {
    result.push({
      title: context.breadCrumbs.dailyData.roomName,
      path: path,
      curmbIsAbsolute: true,
      extInfo: {
        title: context.breadCrumbs.dailyData.roomName,
        type: DAILY_TYPE,
        dailyData: context.breadCrumbs.dailyData,
      },
    });
  }
  if (context.breadCrumbs.strategyData?.jobName) {
    result.push({
      title: context.breadCrumbs.strategyData.jobName,
      extInfo: {
        title: context.breadCrumbs.strategyData.jobName,
        type: STRATEGY_TYPE,
        strategyData: context.breadCrumbs.strategyData,
      },
    });
  }
  if (context.breadCrumbs.poolData?.name) {
    result.push({
      title: context.breadCrumbs.poolData.name,
      extInfo: {
        title: context.breadCrumbs.poolData.name,
        type: POOL_ACT_TYPE,
        poolData: context.breadCrumbs.poolData,
      },
    });
  }
  return result;
}

export default [
  {
    title: '素材收选',
    path: '/materials',
    dynamicChild: true,
    component: MaterialCollectionDaily,
    menus: MyCollectionChildren,
    getCrumb(context) {
      return getTitle(context);
    },
  },
  /* ********* 品店策略相关路由 - start ********** */
  {
    title: '品店策略-新建',
    path: '/strategy-new',
    hideInNav: true,
    component: () => (
      <MicroWrapper showNav={false} headerExtraProps={StrategyNewExtraHeaderProps}>
        <DailyGoodsStrategyNew data={data} />
      </MicroWrapper>
    ),
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '品店策略-触达设置', // 触达配置【第一步：素材触达设置】
    path: '/strategy-set',
    hideInNav: true,
    component: () => (
      <MicroWrapper showNav={false} headerExtraProps={StrategySetExtraHeaderProps}>
        <DailyGoodsStrategySet data={data} />
      </MicroWrapper>
    ),
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '品店策略-触达商品范围设置', // 触达配置【第二步：触达商品范围设置】【第二步只要是第一步选了部分触达才进行】
    path: '/strategy-goods-range',
    hideInNav: true,
    component: () => (
      <MicroWrapper showNav={false} headerExtraProps={StrategyRangeSetExtraHeaderProps}>
        <DailyGoodsStrategyRangeSet data={data} />
      </MicroWrapper>
    ),
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '品店策略-触达记录',
    path: '/strategy-touch-detail',
    hideInNav: true,
    component: DailyGoodsStrategyDetail,
    menus: TouchMenus,
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '详情',
    path: '/strategy-daily-good-detail',
    hideInNav: true,
    component: () => (
      <MicroWrapper showNav={false} headerExtraProps={GoodsDetailSetExtraHeaderProps}>
        <Container>
          <DailyGoodsDetail />
        </Container>
      </MicroWrapper>
    ),
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '商品策略',
    path: '/strategy',
    component: DailyMaterialPoolManage,
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '前台页面',
    path: '/tower-activity',
    component: () => <TowerProject type={2} />,
    getCrumb(context) {
      return getTitle(context);
    },
  },
  /* ********* 品店策略相关路由 - end ********** */
  // {
  //   path: '/activityGoods',
  //   // component: ActivityGoods,
  //   title: '活动选品',
  //   menus: ActivityGoodsChildren
  //   // getlog () {
  //   //   return 'jrhd_1603708380892|6'
  //   // }
  // },
  {
    path: '/ph/*',
    title: '盘货工具',
    menuId: 56,
    hideInNav: true,
    getLink({ path }) {
      return `${path}/phlist/manage`;
    },
    component: () => (
      <MicroWrapper showNav={false}>
        <Microapp
          data={{ basename: '/activity-manage/myCreate/ph' }}
          url={env.MC_DOMAIN + '/phActivity'}
          name="phManage"
        />
      </MicroWrapper>
    ),
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    path: '/zongcuActivity',
    component: () => (
      <MicroWrapper showNav={false}>
        <Zongcu />
      </MicroWrapper>
    ),
    title: '综合促销',
    hideInNav: true,
    menuId: 55,
    menuCode: '005-3',
    menus: zongcuActivityChildren,
    // getlog () {
    //   return 'jrhd_1603708380892|6'
    // }
    getCrumb(context) {
      return getTitle(context);
    },
  },
  // {
  //   path: '/avenue',
  //   // component: ActivityOperate,
  //   title: '通天塔项目',
  //   menus: ActivityOperateChildren,
  //   // getlog () {
  //   //   return 'jrhd_1603708380892|6'
  //   // }
  // },
  {
    path: '/pools',
    // 日常活动微前端嵌入
    title: '',
    menuId: 29,
    hideInNav: true,
    component: () => (
      <MicroWrapper showNav={false}>
        <MyCreateFunc />
      </MicroWrapper>
    ),
    menus: MyCreateFuncChildren,
    // getCrumb() {
    //   return [{ title: '会场活动', path: '/room/activityReceipt' }];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  // 下面是嵌入的许多能力
  {
    path: '/createRoomActivity',
    title: '新建活动',
    hideInNav: true,
    // component: () => {
    //   return (
    //     <Container>
    //       <CreateRoomActivity data={data} />
    //     </Container>
    //   );
    // },
    component: () => (
      <MicroWrapper showNav={false}>
        <AcoreCreateRoomActivity />
      </MicroWrapper>
    ),
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '新建活动', path: '/createRoomActivity' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '资质设置',
    path: '/qualification',
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <QualificationSettings data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '资质设置', path: '/qualification' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '资质平台页面',
    path: '/qualificationForAssembly',
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <QualificationForAssembly data={{ ...data }} sceneType="dailyData" />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '资质设置', path: '/qualification' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '场次设置',
    path: '/scene',
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <SceneSetting data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '场次设置', path: '/scene' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '已报名素材',
    path: '/registeredMaterials',
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <RegisteredMaterials data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '已报名素材', path: '/registeredMaterials' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '收品池设置',
    path: '/poolSetting',
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <CollectionPoolSettings data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '收品池设置', path: '/poolSetting' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '审核管理',
    path: '/auditManagement',
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <AuditManagement data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '审核管理', path: '/auditManagement' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    path: '/signUp',
    title: '报名',
    hideInNav: true,
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <SignUp data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '报名', path: '/signUp' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '分配',
    path: '/distributePage/index',
    component() {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <DistributePage performanceApi={false} data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '分配', path: '/distributePage/index' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    ...routeItem,
    // getCrumb(context) {
    //   const crumbs = routeItem.getCrumb(context);
    //   if (!crumbs) return;
    //   return [{ title: '会场活动', path: '/room/activityReceipt' }, ...crumbs];
    // },
    component() {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <McManage data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '跨场次跳转',
    path: '/crossSessionJumps/batchEditInfo',
    component() {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <CrossSessionJumps data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '跨场次跳转', path: '/crossSessionJumps/batchEditInfo' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  // 这个需要嵌入吗？
  // {
  //   title: '收品池列表',
  //   path: '/poolList',
  //   component: PoolListWrapper,
  //   hideInNav: true,
  // },
  {
    title: '待我审核',
    path: '/managerPending',
    component() {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <ManagerPending data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '待我审核', path: '/managerPending' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '待审核',
    path: '/participantsPending',
    component() {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <ParticipantsPending data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '待审核', path: '/participantsPending' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '选品助手',
    path: '/selectSetting',
    component() {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <SelectSetting data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    // getCrumb() {
    //   return [
    //     { title: '会场活动', path: '/room/activityReceipt' },
    //     { title: '选品助手', path: '/selectSetting' },
    //   ];
    // },
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    title: '直接选品',
    path: '/pandorn/#',
    hideInNav: true,
    component: () => (
      <MicroWrapper showNav={false}>
        <TfPandora inhash="/ntegration/manage/19" data={data} />
      </MicroWrapper>
    ),
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    path: '/pool-rule',
    title: '门槛规则',
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <PoolRule data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    getCrumb(context) {
      return getTitle(context);
    },
  },
  {
    path: '/view-select-rule',
    title: '查看选品规则',
    component: () => {
      return (
        <MicroWrapper showNav={false}>
          <Container>
            <ViewSelectRule data={{ ...data }} />
          </Container>
        </MicroWrapper>
      );
    },
    hideInNav: true,
    getCrumb(context) {
      return getTitle(context);
    },
  },
];
